import React, { FunctionComponent } from 'react';
import RouteHelper from '@jetslash/market-frontend-shared-core/src/utilities/navigation/RouteHelper';
import DesignText from '@/components/typography/DesignText';
import ComponentLink from '@/components/navigation/ComponentLink';
import Icon from '@/components/Icon';
import styles from './SuggestedAirportCard.module.scss';

interface IProps {
  airport: {
    cityAndState: string;
    country: string;
    countryCode: string;
    stateCode: string;
    displayName: string;
    latitude: string;
    longitude: string;
    name: string;
    shortCode: string;
    slug: string;
    timeZone: string;
  };
}

const SuggestedAirportCard: FunctionComponent<IProps> = ({ airport }) => (
  <div className={styles.container}>
    <ComponentLink href={RouteHelper.airportPath(airport.stateCode, airport.shortCode)}>
      <div className={styles.card}>
        <div style={{ position: 'relative' }}>
          <div className={styles.caretIcon}>
            <Icon name="caret-right" />
          </div>
          <DesignText size="xxl" color="primary" style={{ lineHeight: 1 }}>
            {airport.shortCode}
          </DesignText>
        </div>
        <div style={{ marginTop: 4 }}>
          <DesignText size="medium" color="primary" thin>
            {airport.displayName}
          </DesignText>
        </div>
      </div>
    </ComponentLink>
  </div>
);

export default SuggestedAirportCard;
